var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Contract \"Binding\" Acceptance Date"}},[_c('input-date',{attrs:{"name":"contract_acceptance_date","read_only":_vm.read_only},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }